import type { ComponentProps } from 'react';

import { Badge } from '@scaleaq/scaleui';
import { styled } from 'styled-components';

import type { FishWelfareResponse } from './fishObservationGallery.types.ts';
import { orbitOneAnnotationStrokeByType } from './fishObservationSlideView/orbitOneAnnotationOverlay.config.ts';

type LiceObservationBadgeProps = Omit<ComponentProps<typeof Badge>, 'type' | 'outline'> & {
  /** Detection category; picks the border colour that matches the category's box in the image. */
  category: FishWelfareResponse;
};

/**
 * A neutral scaleui `Badge` outlined in the colour of its category's annotation box, so the border
 * works as the colour legend while background and text follow the theme. Categories without an
 * annotation colour keep the badge's default outline.
 */
export const LiceObservationBadge = ({ category, ...badgeProps }: LiceObservationBadgeProps) => (
  <OutlinedBadge
    type='neutral'
    outline
    $borderColor={orbitOneAnnotationStrokeByType[category]}
    {...badgeProps}
  />
);

const OutlinedBadge = styled(Badge)<{ $borderColor?: string }>`
  ${({ $borderColor }) =>
    $borderColor &&
    `
    > div {
      border-color: ${$borderColor};
    }
  `}
`;
